import { ComponentProps, forwardRef } from 'react';

import { cn } from '@/lib/utils';

interface ModalBodyProps extends ComponentProps<'div'> {}

export const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div ref={ref} {...props} className={cn('py-4 flex flex-col space-y-4', className)}>
        {children}
      </div>
    );
  }
);
ModalBody.displayName = 'ModalBody';
